import { useMutation } from "@tanstack/react-query";

import { authClient, verificationCallbackUrl } from "lib/auth/authClient";

/**
 * Hook to resend the signup verification email for a user.
 *
 * `redirect` is optional and only known on flows that carry one (e.g. the register page); passing it
 * keeps the resent link's destination identical to the original email's.
 * @returns A mutation object with methods to trigger the resend and track its status.
 */
export function useResendVerificationEmail() {
  return useMutation({
    mutationFn: async ({ email, redirect }: { email: string; redirect?: string }) => {
      const { data, error } = await authClient.sendVerificationEmail({
        email,
        callbackURL: verificationCallbackUrl({ email, redirect }),
      });
      if (error) {
        throw new Error(error.message ?? "Could not resend verification email");
      }
      return data;
    },
  });
}
